import { Dispatch } from "redux";
import { switcher } from "../../../utils";

export const findRoute = (routes: any) => (next: Dispatch, action: any, dispatch?: Dispatch): void | Promise<any> => {
    return switcher(routes)()(action.route || action.type)(next, action, dispatch);
};
